<template>
  <div
    class="landing-page__product-2"
    :style="`background: ${props.section?.backgroundColor || '#ffffff'}`"
  >
    <div
      class="products-wrap"
      :class="
        productStyleSettings?.position == 'right'
          ? 'products-wrap--right'
          : 'products-wrap--left'
      "
    >
      <div class="hero-image">
        <sib-link
          :to="transformedHeroImageProps.url"
          :title="transformedHeroImageProps.title"
        >
          <sib-image
            class="product__image"
            v-bind="transformedHeroImageProps"
          ></sib-image>
        </sib-link>
      </div>
      <div
        class="products"
        :class="
          productStyleSettings.productColumns == 3
            ? 'products--column-3'
            : 'products--column-2'
        "
        v-if="transformedProductsProps.length"
      >
        <div
          class="product"
          v-for="(product, i) in transformedProductsProps"
          :key="i"
        >
          <sib-link :to="product.url" :title="product.title">
            <sib-image class="product__image" v-bind="product"></sib-image>

            <div class="product__title">{{ product.title }}</div>
            <div class="product__price-formated" v-if="product.price">
              {{ formatPrice(product.price) }}
            </div>
          </sib-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from '@vue/reactivity'
import { formatPrice } from '@/utils/product'

let props = withDefaults(defineProps<{ section: any }>(), {})

const transformedHeroImageProps = computed(() => {
  return {
    width: 1024,
    height: 1024,
    src: props.section.heroImage.image,
    alt: props.section.heroImage.title || '',
    title: props.section.heroImage.title || '',
    url: props.section.heroImage.link,
    sources: [
      {
        size: 361,
        src: props.section.heroImage.image,
      },
      {
        size: 580,
        media: 361,
        src: props.section.heroImage.image,
      },
      {
        size: 768,
        media: 580,
        src: props.section.heroImage.image,
      },
      {
        size: 496,
        media: 768,
        src: props.section.heroImage.image,
      },
      {
        size: 600,
        media: 992,
        src: props.section.heroImage.image,
      },
      {
        size: 650,
        media: 1200,
        src: props.section.heroImage.image,
      },
    ],
    generateSrcSet: true,
  }
})

const transformedProductsProps = computed(() => {
  return props.section.productSettings.products.map((item) => {
    return {
      width: 1024,
      height: 1024,
      src: item.image,
      alt: item.title,
      title: item.title,
      url: item.link,
      price: item.price,
      sources: [
        {
          size: 160,
        },
        {
          size: 265,
          media: 361,
        },
        {
          size: 345,
          media: 576,
        },
        {
          size: 265,
          media: 768,
        },
        {
          size: 300,
          media: 1200,
        },
      ],
      generateSrcSet: true,
    }
  })
})

const productStyleSettings = computed(() => {
  return {
    borderColor: props.section.productSettings?.borderColor || '',
    borderRadius: props.section.productSettings?.borderRadius || '1rem',
    textColor: props.section.productSettings?.textColor || '',
    fontSize: props.section.productSettings?.fontSize || '12px',
    productColumns: props.section.productSettings?.productColumns || 6,
    position: props.section.productSettings?.position || 'left',
  }
})
</script>

<style lang="scss">
.landing-page__product-2 {
  padding-top: 1.5rem;
  padding-bottom: 1rem;
  @include media-md-up() {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .products-wrap {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    &--left {
      grid-template-areas:
        'a'
        'b';
    }
    &--right {
      grid-template-areas:
        'a'
        'b';
    }
    @include media-md-up() {
      grid-template-columns: 1fr 1fr;
      gap: 3rem;
      &--left {
        grid-template-areas: 'b a';
      }
      &--right {
        grid-template-areas: 'a b';
      }
    }
  }
  .hero-image {
    grid-area: a;
    display: flex;
    a,
    .product__image,
    img {
      margin: auto;
    }
    img {
      object-fit: cover;
    }
  }
  .products {
    grid-area: b;
    display: grid;
    &--column-3 {
      grid-template-columns: 1fr 1fr 1fr;
    }
    &--column-2 {
      grid-template-columns: 1fr 1fr;
    }

    gap: 1rem;
    @include media-md-up() {
      gap: 0.5rem 1.5rem;
    }
    .product__image {
      overflow: hidden;
      img {
        border: 4px solid;
        border-color: v-bind('productStyleSettings.borderColor');
        border-radius: v-bind('productStyleSettings.borderRadius');
      }
    }
  }
  .product {
    img {
      border: 4px solid;
      border-color: v-bind('productStyleSettings.borderColor');
      border-radius: v-bind('productStyleSettings.borderRadius');
    }
    &__title {
      font-weight: 500;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      max-height: 3em;
      overflow: hidden;
      color: v-bind('productStyleSettings.textColor');
      font-size: v-bind('productStyleSettings.fontSize');
    }
    &__price-formated {
      margin-top: 2px;
      font-size: 1rem;
      color: v-bind('productStyleSettings.textColor');
    }
    a:hover {
      text-decoration: none;
    }
  }
}
</style>
